import { FC, ReactNode } from 'react';
import { styled, Typography } from '@mui/material';
import { FocusTheme } from '@/components/Focus/configs/theme';

type AvailListContainerProps = {
  children: ReactNode;
  headerRight?: ReactNode;
  heading?: ReactNode;
};

const AvailListContainer: FC<AvailListContainerProps> = ({ children, headerRight, heading }) => (
  <StyledContainer>
    {heading && (
      <StyledHeaderRow>
        <StyledHeading variant="h5">{heading}</StyledHeading>
        {headerRight && <StyledHeaderRight>{headerRight}</StyledHeaderRight>}
      </StyledHeaderRow>
    )}
    {children}
  </StyledContainer>
);

export default AvailListContainer;

export const StyledContainer = styled('div')`
  background: ${({ theme }) => (theme as FocusTheme).palette.neutral[90]};
  padding: ${({ theme }) => theme.spacing(2)};
  border-radius: 10px;
  min-width: 0;
`;

export const StyledScroll = styled('div')`
  overflow-y: auto;
  scrollbar-gutter: stable;
  height: 434px;
  min-width: 0;
`;

export const StyledChildren = styled('div')`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(0.5)};
  padding-right: ${({ theme }) => theme.spacing(1.5)};
  min-width: 0;
`;

const StyledHeaderRow = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(2)};
  padding-right: ${({ theme }) => theme.spacing(2.5)};
  height: 70px;
  min-width: 0;
`;

const StyledHeading = styled(Typography)`
  flex: 1;
  min-width: 0;
  color: ${({ theme }) => (theme as FocusTheme).palette.neutral[20]};
  font-weight: 700;
  font-size: 20px;  // need to redefine in theme
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const StyledHeaderRight = styled('div')`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacing(1)};
  flex-shrink: 0;
`;
